<!--suppress CssUnusedSymbol -->
<template>
  <div
    :style="{ overflow: 'hidden' }"
    class="ps main-menu-wrapp scroll-without-bg"
  >
    <div class="col-auto">
      <div
        style="height: 70px"
        class="main-menu-button"
        @click="toggleMainMenu()"
      >
        <div class="animate-main-menu-bl">
          <div class="top"></div>
          <div class="center"></div>
          <div class="bottom"></div>
        </div>
      </div>
    </div>
    <div class="main-menu" v-if="loaded">
      <ul>
        <li
          @click="openParentLink(link)"
          v-for="link in links"
          v-bind:key="link.id"
          v-bind:class="{ active: link.status && link.children !== undefined }"
        >
          <a
            @click.capture="toggleMainMenuLi(link)"
            v-bind:class="{ 'has-child': link.children !== undefined }"
          >
            <i
              v-if="link.icoType > 0"
              v-bind:class="`ico-type-${link.icoType}`"
            ></i>
            <b>{{ link.title }}</b>
          </a>
          <div v-if="link.children !== undefined">
            <ul>
              <li v-for="child in link.children" v-bind:key="child.id">
                <router-link :to="child.link">
                  <b @click="toggleMainMenu()">{{ child.title }}</b>
                </router-link>
              </li>
            </ul>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import station from "@/router/station";

export default {
  name: "MenuMain",
  components: {},
  props: {
    parameters: Boolean
  },
  data() {
    return {
      mobMenu: true,
      settings: {
        wheelPropagation: true,
        swicher: true,
        wheelSpeed: 0.4
      },
      links: [],
      loaded: false
    };
  },
  methods: {
    toggleMainMenu() {
      this.$store.dispatch("common/toggleMainMenu");
      this.links.forEach(link => {
        link.status = false;
      });
    },
    toggleMainMenuLi(elem) {
      elem.status = !elem.status;
      if (elem.status && elem.children !== undefined) {
        this.$store.dispatch("common/fullMainMenu");
      }
    },
    openParentLink(link) {
      if (link.link !== "#") {
        this.$store.dispatch("common/toggleMainMenu");
        this.$router.push(link.link);
      }
    },
    buildLinks() {
      let links = [
        {
          id: 0,
          title: "Dashboard",
          icoType: 1,
          status: false,
          link: "/station-view/" + this.station.id
        },
        {
          id: 1,
          title: "Устройства",
          icoType: 2,
          status: false,
          link: "#",
          children: [
            {
              id: 0,
              title: "Схема",
              link: "/pdf/" + this.station.id
            },
            {
              id: 1,
              title: "Обзор",
              link: "/schema/" + this.station.id
            }
          ]
        },
        {
          id: 2,
          title: "События",
          icoType: 3,
          status: false,
          link: "#"
        },
        {
          id: 3,
          title: "Отчеты",
          icoType: 4,
          status: false,
          link: "/statistics/" + this.station.id
        },
        {
          id: 4,
          title: "Analytics",
          icoType: 5,
          status: false,
          link:
            (this.station.id === 3 ? "/analytics/" : "/analytics-old/") +
            this.station.id
        },
        {
          id: 5,
          title: "Настройки станции",
          icoType: 6,
          status: false,
          link: "/station-edit/" + this.station.id
        }
      ];

      if (this.station.meteo !== null && this.station.meteo.meteo_station) {
        links.push({
          id: 6,
          title: "Погода",
          icoType: 7,
          status: false,
          link: "/weather/" + this.station.id
        });
      }

      this.station.deviceTypes.forEach((type, idx) => {
        links[1].children.push({
          id: 2 + idx,
          title: type.title,
          link: "/device-list/" + this.station.id + "/" + type.id
        });
      });

      if ([35, 36, 39, 57, 58].includes(this.station.id)) {
        let count = links[1].children.length;
        links[1].children.push({
          id: count,
          title: "Grid inverters",
          link: "/inverters-new/" + this.station.id
        });
      }

      this.links = links;
      this.loaded = true;
    }
  },
  computed: {
    hasStation() {
      return this.$store.getters["station/hasStation"];
    },
    station() {
      return this.$store.getters["station/station"];
    }
  },
  mounted() {
    if (this.hasStation) {
      this.buildLinks();
    } else {
      let unsubscribe = null;

      unsubscribe = this.$store.subscribe(({ type }) => {
        if (type === "station/FETCHING_STATION_SUCCESS") {
          this.buildLinks();
          unsubscribe();
        }
      });
    }
  }
};
</script>
